export enum MetrikaGoals {
    getWigetCode = 'get_wiget_code',
    copyWigetCode = 'copy_wiget_code',
}

declare global {
    interface Window {
        ym: (company: number, method: string, type: string) => void;
    }
}

export const reachGoal = (type: MetrikaGoals): void => {
    window.ym(67734844, 'reachGoal', type);
};
